<template>
    <div :class="{'mt-3':!isMultipleOption}">
        <div class="row" role="group">
            <div class="col-md-12" v-for="(choice, index) in choices" :key="choice.value">
                <div class="form-check" :class="{ 'ps-0': isMultipleOption }">
                    <label class="form-check-label" :for="name + index" :class="[fieldInnerClass, {disabled: choice.value !== 'none' && selectedValues.includes('none'), 'fs-5 check-row': isMultipleOption}]">
                        <input v-if="isMultipleOption" class="form-check-input" type="checkbox"
                            :name="name" :id="name + index"
                            :value="choice.value"
                            :key="choice.value"
                            :disabled="choice.value !== 'none' && selectedValues.includes('none')"
                            :checked="selectedValues.includes(choice.value)"
                            @change="handleChanges(choice, $event)"
                        />
                        <input v-else class="form-check-input" type="checkbox"
                            :name="name" :id="name + index"
                            :true-value="true"
                            :false-value="false"
                            v-model="custom"
                            :checked="value === true"
                        />
                        <span v-html="getTranslatedText(choice.text, 'fields.options')"></span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, computed, inject } from 'vue';

const props = defineProps({
    choices: { type: Array, required: true },
    value: { type: [String, Number, Boolean, Array], default: undefined },
    name: { type: String, required: true },
    label: { type: String, default: '' },
    fieldInnerClass: { type: String, default: undefined },
    isMultipleOption: { type: Boolean, default: false },
});
const emit = defineEmits(["update:model-value","input"]);

const { getTranslatedText } = inject('app');

const selectedValues = ref([]);

const custom = computed({
    get() { return props.value; },
    set(v) { emit('input', v); }
});

function handleChanges(choice, event) {
    if (choice.value === "none") {
        selectedValues.value = event.target.checked ? ['none'] : [];
    } else {
        if (event.target.checked) {
            selectedValues.value = selectedValues.value.filter((v) => v !== "none");
            selectedValues.value.push(choice.value);
        } else {
            selectedValues.value = selectedValues.value.filter((v) => v !== choice.value);
        }
    }
    emit("input", selectedValues.value.length === 0 ? null : selectedValues.value);
}
</script>
<style scoped>

/* Each "select all that apply" row is a 44px touch target (Apple HIG, WCAG 2.5.5). The rows sit
   flush, so at the text's own 29px height a thumb often lands on the neighbouring box.
   Laid out with flex rather than Bootstrap's float + negative margin: that pulls the box back by
   1.5em of the larger fs-5 label font, more than .form-check's 24px indent, which pushed the
   checkbox past the card's content edge on phones. */
.check-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding-block: 0.5rem;
    padding-inline: 0.5rem;
}

.check-row .form-check-input {
    float: none;
    flex: none;
    margin: 0;
}

.form-check .disabled {
    cursor: not-allowed;
    opacity: .5;
}


.large-checkbox .form-check-input {}
.large-checkbox span {}

@media (min-width: 768px) {
    .large-checkbox .form-check-input {
        width: 30px;
        height: 30px;
        margin: 5px 10px 50px auto;
    }
    .large-checkbox span {
        font-size: 14px;
    }
}

</style>
